import React from 'react';
import { Spinner } from 'react-bootstrap';
import { patientServiceEvents, ServicesContext } from '~/services';
import { useServiceSubscribe } from '~/util';
import { Reminder, AddReminder } from '~/components/Reminders';

interface ReminderFeedProps {
    performAdd: (description: string, date: string) => void;
    loadEntity: string;
    patient?: null | PatientType;
    setTabValue?: (x: number) => void;
    enableOpenModal?: boolean;
    addReminderOpen?: boolean;
    isPCMView?: boolean;
}
export function ReminderFeed({
    performAdd,
    loadEntity,
    patient = null,
    setTabValue,
    enableOpenModal = false,
    addReminderOpen = false,
    isPCMView = false,
}: ReminderFeedProps) {
    const servicesContext = React.useContext(ServicesContext);
    const [loading, setLoading] = React.useState(false);
    const [reminderOpen, setReminderOpen] = React.useState(addReminderOpen);
    const [reminderFeed, setReminderFeed] = React.useState<ReminderType[]>([]);
    const [viewClosed, setViewClosed] = React.useState(false);

    const loadReminders = React.useCallback(async () => {
        setLoading(true);
        const reminders = await servicesContext.patient.getReminders(loadEntity, viewClosed);
        setReminderFeed(reminders.results);
        if (!viewClosed && setTabValue) {
            setTabValue(reminders.results.length);
        }
        setLoading(false);
    }, [loadEntity, servicesContext.patient, viewClosed, setTabValue]);

    React.useEffect(() => {
        loadReminders();
    }, [loadReminders, viewClosed]);

    useServiceSubscribe(patientServiceEvents.reminders_updated, loadReminders);

    function toggleReminder() {
        setReminderOpen((prev) => !prev);
    }

    return (
        <div className="reminders">
            <div className="row add-reminder mb-2 align-items-baseline">
                <div className="col-6">
                    <label className="form-label">
                        <input
                            type="checkbox"
                            name="showclosedreminders"
                            className="me-2"
                            checked={viewClosed}
                            onChange={(e) => setViewClosed(e.target.checked)}
                        />
                        Only show closed
                    </label>
                </div>
                <div className="col-6 h4">
                    <button
                        type="button"
                        className={`btn pull-right add-reminder-toggle ${reminderOpen ? 'btn-danger' : 'btn-success'}`}
                        onClick={toggleReminder}
                    >
                        <i
                            className={`fa-solid ${
                                reminderOpen ? 'fa-minus-circle' : 'fa-plus-circle'
                            }`}
                        />{' '}
                        {reminderOpen ? 'Close Reminder' : 'Add Reminder'}
                    </button>
                </div>
            </div>
            {reminderOpen && (
                <AddReminder performAdd={performAdd} setReminderOpen={toggleReminder} />
            )}
            <hr />
            <div className={reminderOpen ? 'reminder-scroll-small' : 'reminder-scroll'}>
                {loading && (
                    <div className="text-center pb-3">
                        <Spinner animation="border" />
                    </div>
                )}
                {reminderFeed.map((x) => (
                    <Reminder
                        key={`${x.id}-${x.status}`}
                        reminder={x}
                        patient={patient}
                        enableOpenModal={enableOpenModal}
                        isPCMView={isPCMView}
                    />
                ))}
            </div>
        </div>
    );
}
